/**
 * Created by jonas on 2020-03-18.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {SpacierArcadeGameAssets} from "../SpacierArcadeGameAssets";
import {SASlideShowPage} from "./SASlideShowPage";

export class SpacierArcadeIntroConfig implements GameIntroViewConfig {

    colors:GameIntroColors = {
        slideShowColors:{
            backgroundColor:0x000000,
            backgroundAlpha:0.6,
            bulletColor:0xffffff
        },
        stampColor:0xFFFFFF,
    };


    stampConfig:StampConfig = {
        xWays:false,
        xNudge:false,
        volatility:Volatility.MEDIUM
    };

    background:PIXI.Container;
    borderBottom:PIXI.Container;
    borderTop:PIXI.Container;
    logo:PIXI.Container;
    pages:SlideShowPage[];

    constructor() {
    }

    public init():Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add(SpacierArcadeGameAssets.INTRO_BACKGROUND, SpacierArcadeGameAssets.INTRO_BACKGROUND);
        imgLoader.add(SpacierArcadeGameAssets.LOGO_LANDSCAPE, SpacierArcadeGameAssets.LOGO_LANDSCAPE);
        imgLoader.add(SpacierArcadeGameAssets.INTRO_FEATURE_1, SpacierArcadeGameAssets.INTRO_FEATURE_1);
        imgLoader.add(SpacierArcadeGameAssets.INTRO_FEATURE_2, SpacierArcadeGameAssets.INTRO_FEATURE_2);
        imgLoader.add(SpacierArcadeGameAssets.INTRO_BUY_FEATURE_ICON, SpacierArcadeGameAssets.INTRO_BUY_FEATURE_ICON);


        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture(SpacierArcadeGameAssets.INTRO_BACKGROUND));
        bgSprite.anchor.set(0.5, 0.5);
        bgSprite.scale.set(0.93);
        bgSprite.position.set(0, 30);

        this.background.addChild(bgSprite);
        this.borderTop = new PIXI.Container();
        this.borderBottom = new PIXI.Container();
        this.logo = new PIXI.Container();
        const logo = new PIXI.Sprite(ImgLoader.getImgTexture(SpacierArcadeGameAssets.LOGO_LANDSCAPE));
        logo.scale.set(0.6);
        logo.anchor.set(0.5, 0.5);
        this.logo.addChild(logo);

        this.pages = [
            new SASlideShowPage(ImgLoader.getImgTexture(SpacierArcadeGameAssets.INTRO_FEATURE_1), ImgLoader.getImgTexture(SpacierArcadeGameAssets.INTRO_FEATURE_2))
        ];
    }
}